/* GoGo Solar — per-product reviews on product pages.
   Pulls that product's own reviews from Fera and renders them under the
   product but ABOVE the Judge.me widget and the “You may also like”
   recommendations.

   Order matters here. Judge.me is now the app collecting NEW reviews, but
   it starts empty, so its block says “Be the first to write a review”. The
   200 historic reviews still live in Fera. If the Judge.me block renders
   first, a light with 22 reviews shows “Be the first to write a review”
   directly above its own 4.7 average, which reads as broken. So the Fera
   block is inserted before the Judge.me section, and the write-a-review
   button sits underneath the reviews it belongs to.

   Dates are deliberately not shown. Fera's created_at is the date each
   review was imported, not the date it was written, so displaying it would
   be wrong. Fixing that means correcting the data in Fera, not here.

   Fera's product handles came from the Wix site and don't match the Shopify
   ones, so products are matched by name. The page title carries an SEO
   suffix, so the <h1> is used first and og:title only as a fallback. */
(function () {
  var PK = "pk_d041f3dbf86e19d04fb72ef4a8822eea88bd9f17652622e746ab19c2ac1ad681";
  var API = "https://api.fera.ai/v3/public/reviews";
  var PER = 12;

  var GOLD = "#F5A800";
  var INK = "#171A15";
  var MUTED = "#6E7268";

  var FERA = {
    "300W Solar Flood Light": "fpro_IwVXZ2Nf",
    "800W Solar Street Light": "fpro_Iw6j5LQh",
    "2000W LED Street Light": "fpro_IqGWeuAW",
    "20W LED Solar Outdoor Lights": "fpro_IqGWe4Gb",
    "2500W Ultra Solar Street Light": "fpro_Iw6iS02U",
    "400W Led Street Lights": "fpro_IqGWfk4R",
    "Solar Ceiling Light": "fpro_Iw6ggKt3",
    "2IN1 Solar/Electric Light": "fpro_IwVJBUpY",
    "Garden Solar Lamp": "fpro_Iw6hzXNE",
    "1800W Solar Street Light With Panel": "fpro_Iw6i7uOQ",
    "UFO Solar Street Light": "fpro_Iw6dYxXg",
    "AI 12MP 4 lense Solar CCTV Camera": "fpro_Iw6iDlhr",
    "3000W Solar Street Light": "fpro_Iw6iNoWt",
    "AI 4K Smart Lenes Wired CCTV": "fpro_Iw6iC5u1",
    "1500W CCTV Solar Light": "fpro_Iw6hebpF",
    "Solar Fan With Panel": "fpro_Iw6gykjH",
    "Office Solar Fan With Panel": "fpro_Iw6h7xeO",
    "10W + 252W Street Lights": "fpro_IwUf3YJE"
  };

  function norm(s) {
    return (s || "").toLowerCase().replace(/[^a-z0-9]+/g, "");
  }

  function feraId(title) {
    if (FERA[title]) return FERA[title];

    var t = norm(title);
    for (var k in FERA) if (norm(k) === t) return FERA[k];

    /* last resort: match on the wattage token, e.g. 2500w */
    var w = (title.match(/\b(\d{2,4})\s*w\b/i) || [])[1];
    if (w) {
      for (var k2 in FERA) {
        var w2 = (k2.match(/\b(\d{2,4})\s*w\b/i) || [])[1];
        if (w2 && w2 === w) return FERA[k2];
      }
    }
    return null;
  }

  function esc(s) {
    return (s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  function stars(n) {
    var r = Math.round(n || 0), out = "";
    for (var i = 1; i <= 5; i++) out += i <= r ? "★" : "☆";
    return out;
  }

  function styles() {
    if (document.getElementById("bsl-pr-style")) return;
    var s = document.createElement("style");
    s.id = "bsl-pr-style";
    s.textContent = [
      ".bsl-pr{margin:3.5rem auto 1rem;max-width:1100px;padding:0 1.5rem;" +
        "font-family:Inter,system-ui,sans-serif}",
      ".bsl-pr-head{display:flex;flex-wrap:wrap;align-items:flex-end;justify-content:space-between;" +
        "gap:1rem;padding-bottom:1.1rem;border-bottom:1px solid rgba(23,26,21,.12)}",
      ".bsl-pr h2{font-family:Satoshi,ui-sans-serif,system-ui,sans-serif;font-weight:900;" +
        "font-size:1.6rem;line-height:1.1;letter-spacing:-.02em;color:" + INK + ";margin:0}",
      ".bsl-pr-score{display:flex;align-items:center;gap:.7rem}",
      ".bsl-pr-score .num{font-size:1.7rem;font-weight:700;color:" + INK + ";line-height:1}",
      ".bsl-pr-score .st{color:" + GOLD + ";font-size:1rem;letter-spacing:.1em;line-height:1.2}",
      ".bsl-pr-score .meta{font-size:.78rem;color:" + MUTED + ";line-height:1.4}",

      ".bsl-pr-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:1rem;" +
        "margin-top:1.5rem}",
      "@media(max-width:980px){.bsl-pr-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}",
      "@media(max-width:640px){.bsl-pr-grid{grid-template-columns:1fr}}",

      ".bsl-pr-card{background:#fff;border:1px solid rgba(23,26,21,.10);border-radius:16px;" +
        "padding:1.25rem 1.3rem;display:flex;flex-direction:column;gap:.6rem}",
      ".bsl-pr-card .st{color:" + GOLD + ";font-size:.9rem;letter-spacing:.1em}",
      ".bsl-pr-card h3{font-family:Satoshi,ui-sans-serif,system-ui,sans-serif;font-weight:700;" +
        "font-size:.98rem;color:" + INK + ";margin:0;line-height:1.35}",
      ".bsl-pr-card p{font-size:.9rem;line-height:1.6;color:#333A31;margin:0;flex:1}",
      ".bsl-pr-foot{display:flex;align-items:center;justify-content:space-between;gap:.6rem;" +
        "border-top:1px solid rgba(23,26,21,.10);padding-top:.7rem;font-size:.78rem;color:" + MUTED + "}",
      ".bsl-pr-foot b{color:" + INK + ";font-weight:600}",
      ".bsl-pr-ver{color:" + GOLD + ";font-weight:700}",

      ".bsl-pr-more{display:inline-block;margin-top:1.4rem;font-size:.84rem;color:" + MUTED + ";" +
        "text-decoration:underline;text-underline-offset:3px;cursor:pointer;background:none;border:0;" +
        "font-family:inherit;padding:0}",
      ".bsl-pr-more:hover{color:" + INK + "}",
      ".bsl-pr-none{margin-top:1.2rem;font-size:.9rem;color:" + MUTED + "}"
    ].join("");
    document.head.appendChild(s);
  }

  function productTitle() {
    var h1 = document.querySelector("#MainContent h1");
    if (h1 && h1.textContent.trim()) return h1.textContent.trim();
    var meta = document.querySelector('meta[property="og:title"]');
    if (meta && meta.content) return meta.content.split("|")[0].trim();
    return "";
  }

  /* Where the Fera block goes. The Judge.me section is preferred so the
     historic reviews sit above the write-a-review block; the
     recommendations are the fallback if Judge.me is not on the page. */
  function anchor(main) {
    var kids = main.children, i;

    for (i = 0; i < kids.length; i++) {
      if (kids[i].querySelector(
        '.jdgm-review-widget, .jm-review-widget, [class*="jdgm-rev-widg"], [class*="jdgm-widget"]'
      )) return kids[i];
    }

    for (i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (/recommendation|related/i.test(el.id || "")) return el;
      var h = el.querySelector("h2, h3");
      if (h && /you may also like|recommend|related|complete the look/i.test(h.textContent)) return el;
    }
    return null;
  }

  function card(r) {
    var name = (r.customer && (r.customer.display_name || r.customer.name)) || "Verified customer";
    return (
      '<article class="bsl-pr-card">' +
        '<div class="st">' + stars(r.rating) + "</div>" +
        (r.heading ? "<h3>" + esc(r.heading) + "</h3>" : "") +
        "<p>" + esc(r.body || "") + "</p>" +
        '<div class="bsl-pr-foot"><b>' + esc(name) + "</b>" +
          (r.is_verified ? '<span class="bsl-pr-ver">✓ Verified buyer</span>' : "<span></span>") +
        "</div>" +
      "</article>"
    );
  }

  function render(box, data, meta, id, page) {
    var list = box.querySelector(".bsl-pr-grid");
    list.insertAdjacentHTML("beforeend", data.map(card).join(""));

    var old = box.querySelector(".bsl-pr-more");
    if (old) old.remove();

    if (meta && meta.page < meta.page_count) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "bsl-pr-more";
      b.textContent = "Show more reviews";
      b.addEventListener("click", function () {
        b.textContent = "Loading…";
        load(box, id, page + 1);
      });
      box.appendChild(b);
    }
  }

  function load(box, id, page) {
    fetch(API + "?public_key=" + PK + "&product_id=" + encodeURIComponent(id) +
          "&per_page=" + PER + "&page=" + page)
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var data = j.data || [];
        if (!data.length && page === 1) {
          /* no historic reviews for this light — let Judge.me's own empty
             state do the talking rather than showing two of them */
          box.remove();
          return;
        }
        render(box, data, j.meta, id, page);

        if (page === 1 && data[0] && data[0].product && data[0].product.rating) {
          var rt = data[0].product.rating;
          var sc = box.querySelector(".bsl-pr-score");
          if (sc) {
            sc.innerHTML =
              '<span class="num">' + (Math.round(rt.average * 10) / 10) + "</span>" +
              '<span><span class="st">' + stars(rt.average) + "</span><br>" +
              '<span class="meta">' + rt.count + " review" + (rt.count === 1 ? "" : "s") +
              " for this light</span></span>";
          }
        }
      })
      .catch(function () {
        var b = box.querySelector(".bsl-pr-more");
        if (b) b.textContent = "Show more reviews";
      });
  }

  function run() {
    var main = document.getElementById("MainContent");
    if (!main) return;
    if ((main.getAttribute("data-template") || "").indexOf("product") === -1) return;

    var existing = document.querySelector(".bsl-pr");
    var anch = anchor(main);

    /* the Judge.me block and the recommendations both load in late — if one
       turned up after us, move above it */
    if (existing) {
      if (anch && existing.compareDocumentPosition(anch) & Node.DOCUMENT_POSITION_PRECEDING) {
        main.insertBefore(existing, anch);
      }
      return;
    }

    var title = productTitle();
    var id = feraId(title);
    if (!id) return;

    styles();

    var box = document.createElement("section");
    box.className = "bsl-pr";
    box.innerHTML =
      '<div class="bsl-pr-head">' +
        "<h2>What customers say about this light</h2>" +
        '<div class="bsl-pr-score"></div>' +
      "</div>" +
      '<div class="bsl-pr-grid"></div>';

    if (anch) main.insertBefore(box, anch);
    else main.appendChild(box);

    load(box, id, 1);
  }

  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);
  document.addEventListener("shopify:section:load", run);
  window.addEventListener("load", run);
})();
